import React,{useContext, useEffect} from "react";
import { Link } from "react-router-dom";
import "./styles.css";
import routes from "../../routes";
import AppContext from "../../context";
import classNames from 'classnames'





const Header: React.FC = () => {
  const data = useContext(AppContext.AppCtx); 
  const {yPosition} = data
  
  useEffect(()=>{
    console.log(yPosition)
  },[yPosition])

  return (
    <div 
    className={classNames("header", {
      headerMove: yPosition<0,
    })}
    >
      <div className="containerLogo">
        <img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1662075065/just/Logo-just-Danger_avb1dy.png" alt="Logo" />
      </div>
      <ul className="nav">
        {routes.map((route) => (
          <li  key={route.key}>
            <Link  to={route.path}>{route.title}</Link>
          </li>
        ))}
      </ul>
      <div className="containerLogoRedes">
        <Link to="#"><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1664066062/just/facebook_x8ghrf.png"/></Link>
        <Link to="#"><img src="https://res.cloudinary.com/ddoltb8nf/image/upload/v1664066062/just/instagram_ibkoop.png"/></Link>
      </div>
    </div>
  );
};

export default Header;
